export var isMobileDevice = function (userAgent) {
    return isIosDevice(userAgent) || isAndroidDevice(userAgent);
};
export var isAndroidDevice = function (userAgent) { return /Android/i.test(userAgent); };
export var isIphoneDevice = function (userAgent) { return /iPhone/i.test(userAgent); };
export var isIpadDevice = function (userAgent) { return /iPad/i.test(userAgent); };
export var isIosDevice = function (userAgent) {
    return isIpadDevice(userAgent) || isIphoneDevice(userAgent);
};
